import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'cmv-authorized-cnbv',
	templateUrl: './authorized-cnbv.component.html',
	styleUrls: ['./authorized-cnbv.component.scss'],
})
export class AuthorizedCnbvComponent {
	constructor() {}
}
